export const EXTERNAL_LINK = {
  WHITE_PAPER: "https://docs.llamaland.io/",
  ZH_TW_WHITE_PAPER: "https://docs-zh.llamaland.io/llama-land/about",
  DISCORD: "https://discord.com/invite/NtwCbNXYKR",
  TWITTER: "https://twitter.com/llamaland_game",
  PROMOTIONAL_YOUTUBE_VIDEO_ID: "SrE52NYjEfU",
};
